import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ConflictDetection = ({ 
  conflicts = [], 
  onResolveConflict, 
  onDismissConflict,
  className = ''
}) => {
  const mockConflicts = [
    {
      id: 1,
      type: 'overlap',
      severity: 'high',
      title: 'Overlapping Shifts Detected',
      description: 'John Smith has overlapping shifts on January 5th',
      details: {
        employee: 'John Smith (EMP001)',
        date: '2025-01-05',
        shifts: [
          { id: 1, time: '08:00 - 16:00', location: 'Factory Floor A' },
          { id: 2, time: '14:00 - 22:00', location: 'Warehouse B' }
        ]
      },
      suggestions: [
        'Adjust shift times to avoid overlap',
        'Assign one shift to another employee',
        'Split the overlapping period'
      ]
    },
    {
      id: 2,
      type: 'availability',
      severity: 'medium',
      title: 'Employee Availability Issue',
      description: 'Sarah Johnson is scheduled during requested time off',
      details: {
        employee: 'Sarah Johnson (EMP002)',
        date: '2025-01-06',
        shift: { time: '09:00 - 17:00', location: 'Warehouse A' },
        conflict: 'Requested time off: January 6-8'
      },
      suggestions: [
        'Reschedule shift to available dates',
        'Assign shift to available employee',
        'Approve overtime if urgent'
      ]
    },
    {
      id: 3,
      type: 'capacity',
      severity: 'low',
      title: 'Location Over-capacity',
      description: 'QC Lab has more employees scheduled than capacity allows',
      details: {
        location: 'QC Lab',
        date: '2025-01-07',
        capacity: 3,
        scheduled: 4,
        employees: ['Mike Davis', 'Anna Taylor', 'Lisa Wilson', 'David Brown']
      },
      suggestions: [
        'Move one employee to alternate location',
        'Stagger shift times',
        'Increase location capacity if possible'
      ]
    }
  ];

  const allConflicts = [...conflicts, ...mockConflicts];

  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'high':
        return 'border-error bg-error/5 text-error';
      case 'medium':
        return 'border-warning bg-warning/5 text-warning';
      case 'low':
        return 'border-blue-500 bg-blue-50 text-blue-700';
      default:
        return 'border-border bg-muted/30 text-text-primary';
    }
  };

  const getSeverityIcon = (severity) => {
    switch (severity) {
      case 'high':
        return 'AlertTriangle';
      case 'medium':
        return 'AlertCircle';
      case 'low':
        return 'Info';
      default:
        return 'AlertCircle';
    }
  };

  const getTypeIcon = (type) => {
    switch (type) {
      case 'overlap':
        return 'Overlap';
      case 'availability':
        return 'UserX';
      case 'capacity':
        return 'Users';
      default:
        return 'AlertCircle';
    }
  };

  const handleResolve = (conflict, action) => {
    if (onResolveConflict) {
      onResolveConflict(conflict, action);
    }
  };

  const handleDismiss = (conflictId) => {
    if (onDismissConflict) {
      onDismissConflict(conflictId);
    }
  };

  if (allConflicts?.length === 0) {
    return (
      <div className={`bg-success/5 border border-success/20 rounded-lg p-4 ${className}`}>
        <div className="flex items-center space-x-2">
          <Icon name="CheckCircle" size={20} className="text-success" />
          <span className="text-success font-medium">No conflicts detected</span>
        </div>
        <p className="text-sm text-success/80 mt-1">
          All shifts are properly scheduled without conflicts
        </p>
      </div>
    );
  }

  return (
    <div className={`space-y-4 ${className}`}>
      {/* Header */}
      {/* <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <Icon name="AlertTriangle" size={20} className="text-warning" />
          <h3 className="font-medium text-text-primary">
            Scheduling Conflicts ({allConflicts?.length})
          </h3>
        </div>
        
        <Button
          variant="outline"
          size="sm"
          onClick={() => {
            allConflicts?.forEach(conflict => handleDismiss(conflict?.id));
          }}
          iconName="X"
          iconPosition="left"
          className="touch-feedback"
        >
          Dismiss All
        </Button>
      </div> */}
      {/* Conflicts List */}
      {/* <div className="space-y-3">
        {allConflicts?.map((conflict) => (
          <div
            key={conflict?.id}
            className={`border rounded-lg p-4 ${getSeverityColor(conflict?.severity)}`}
          >
            
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-start space-x-3">
                <div className="flex items-center space-x-2">
                  <Icon 
                    name={getSeverityIcon(conflict?.severity)} 
                    size={20} 
                    className="flex-shrink-0" 
                  />
                  <Icon 
                    name={getTypeIcon(conflict?.type)} 
                    size={16} 
                    className="flex-shrink-0 opacity-60" 
                  />
                </div>
                
                <div>
                  <h4 className="font-medium">{conflict?.title}</h4>
                  <p className="text-sm opacity-80 mt-1">{conflict?.description}</p>
                </div>
              </div>
              
              <Button
                variant="ghost"
                size="sm"
                onClick={() => handleDismiss(conflict?.id)}
                iconName="X"
                className="touch-feedback opacity-60 hover:opacity-100"
              />
            </div>

            <div className="bg-white/50 rounded-md p-3 mb-3 text-sm">
              {conflict?.type === 'overlap' && (
                <div className="space-y-2">
                  <div><strong>Employee:</strong> {conflict?.details?.employee}</div>
                  <div><strong>Date:</strong> {conflict?.details?.date}</div>
                  <div><strong>Conflicting Shifts:</strong></div>
                  <ul className="list-disc list-inside ml-4 space-y-1">
                    {conflict?.details?.shifts?.map((shift, index) => (
                      <li key={index}>
                        {shift?.time} at {shift?.location}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              
              {conflict?.type === 'availability' && (
                <div className="space-y-2">
                  <div><strong>Employee:</strong> {conflict?.details?.employee}</div>
                  <div><strong>Date:</strong> {conflict?.details?.date}</div>
                  <div><strong>Scheduled:</strong> {conflict?.details?.shift?.time} at {conflict?.details?.shift?.location}</div>
                  <div><strong>Conflict:</strong> {conflict?.details?.conflict}</div>
                </div>
              )}
              
              {conflict?.type === 'capacity' && (
                <div className="space-y-2">
                  <div><strong>Location:</strong> {conflict?.details?.location}</div>
                  <div><strong>Date:</strong> {conflict?.details?.date}</div>
                  <div><strong>Capacity:</strong> {conflict?.details?.capacity} employees</div>
                  <div><strong>Scheduled:</strong> {conflict?.details?.scheduled} employees</div>
                  <div><strong>Employees:</strong> {conflict?.details?.employees?.join(', ')}</div>
                </div>
              )}
            </div>

            <div className="mb-4">
              <h5 className="font-medium text-sm mb-2">Suggested Solutions:</h5>
              <ul className="list-disc list-inside text-sm space-y-1 opacity-80">
                {conflict?.suggestions?.map((suggestion, index) => (
                  <li key={index}>{suggestion}</li>
                ))}
              </ul>
            </div>

            <div className="flex items-center space-x-2">
              <Button
                variant="outline"
                size="sm"
                onClick={() => handleResolve(conflict, 'auto')}
                iconName="Zap"
                iconPosition="left"
                className="touch-feedback bg-white/50 hover:bg-white/70"
              >
                Auto-Resolve
              </Button>
              
              <Button
                variant="outline"
                size="sm"
                onClick={() => handleResolve(conflict, 'manual')}
                iconName="Edit"
                iconPosition="left"
                className="touch-feedback bg-white/50 hover:bg-white/70"
              >
                Manual Fix
              </Button>
              
              <Button
                variant="outline"
                size="sm"
                onClick={() => handleResolve(conflict, 'view')}
                iconName="Eye"
                iconPosition="left"
                className="touch-feedback bg-white/50 hover:bg-white/70"
              >
                View Details
              </Button>
            </div>
          </div>
        ))}
      </div> */}
      {/* Summary */}
      {/* <div className="bg-muted/30 rounded-lg p-4">
        <div className="flex items-center justify-between">
          <div className="text-sm text-text-secondary">
            <strong>{allConflicts?.filter(c => c?.severity === 'high')?.length}</strong> high priority, 
            <strong className="ml-1">{allConflicts?.filter(c => c?.severity === 'medium')?.length}</strong> medium priority, 
            <strong className="ml-1">{allConflicts?.filter(c => c?.severity === 'low')?.length}</strong> low priority conflicts
          </div>
          
          <Button
            variant="default"
            size="sm"
            onClick={() => {
              allConflicts?.forEach(conflict => handleResolve(conflict, 'auto'));
            }}
            iconName="Zap"
            iconPosition="left"
            className="touch-feedback"
          >
            Auto-Resolve All
          </Button>
        </div>
      </div> */}
    </div>
  );
};

export default ConflictDetection;